import { render } from "./HrmisCrudModule.vue?vue&type=template&id=57065793&scoped=true"
import script from "./HrmisCrudModule.vue?vue&type=script&lang=js"
export * from "./HrmisCrudModule.vue?vue&type=script&lang=js"

import "./HrmisCrudModule.vue?vue&type=style&index=0&id=57065793&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57065793"]])

export default __exports__